import { atom } from '@zedux/react'

const mailSubjectAtom = atom("mailSubjectAtom", "")

export default mailSubjectAtom